import {Directions} from '@jetbrains/ring-ui/components/popup/popup.consts'
import {memo} from 'react'

import useMyId from '../../../../../hooks/useMyId'
import {UserProperties} from '../../../../../utils/userProperties'
import NewFeaturePopup from '../../../../common/NewFeaturePopup/NewFeaturePopup'
import {useNewFeatureProperty} from '../../../../common/NewFeaturePopup/NewFeaturePopup.hook'
import {isPipelinesAgentPageNewFeaturePopupEnabled} from '../../utils/featureToggles'

function AgentNewFeaturePopup() {
  const [isFeatureSeen, setFeatureAsSeen] = useNewFeatureProperty(
    UserProperties.HAS_PIPELINE_AGENT_PAGES_BEEN_SEEN,
  )
  const myId = useMyId()

  if (isFeatureSeen || !isPipelinesAgentPageNewFeaturePopupEnabled || myId == null || myId < 0) {
    return null
  }

  const onClose = () => {
    setFeatureAsSeen()
  }

  return (
    <NewFeaturePopup
      directions={[Directions.RIGHT_BOTTOM]}
      title={'New agents page'}
      description={'Explore the JetBrains-hosted agents or set up your own self-hosted agents.'}
      onClose={onClose}
    />
  )
}

export default memo(AgentNewFeaturePopup)
